module.exports = __webpack_public_path__ + "static/media/heart_state_header@2x.4f6dde7e.png";